import React from "react";
import { Grid } from "@material-ui/core";
import { PickupStatus, PickupDetails, PickupInfoGrid } from "../components";

const RightInfoPanel = ({ pickupinfo }) => {
  return (
    <Grid container spacing={24}>
      <Grid item xs={12}>
        <PickupStatus data={pickupinfo} />
      </Grid>
      <Grid item xs={12}>
        <PickupDetails pickupinfo={pickupinfo} />
      </Grid>
      <Grid item xs={12}>
        <PickupInfoGrid pickupinfo={pickupinfo} />
      </Grid>
    </Grid>
  );
};

export default RightInfoPanel;
